import React, { useState, useMemo } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Quiz from "@/pages/Quiz";
import Result from "@/pages/Result";
import LanguageToggle from "@/components/LanguageToggle";
import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import { generateResult } from "@/lib/scoring";

function AppInner() {
  const { lang } = useLang();
  const [screen, setScreen] = useState("home"); // home | quiz | result
  const [answers, setAnswers] = useState(null);

  const result = useMemo(() => {
    if (!answers) return null;
    return generateResult(answers, lang);
  }, [answers, lang]);

  const startQuiz = () => {
    setAnswers(null);
    setScreen("quiz");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const completeQuiz = (allAnswers) => {
    setAnswers(allAnswers);
    setScreen("result");
    window.scrollTo({ top: 0 });
  };

  const restart = () => {
    setAnswers(null);
    setScreen("home");
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(43,40,37,0.12)",
            color: "#2B2825",
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: "14px",
          },
        }}
      />
      <LanguageToggle />
      {screen === "home" && <Home onStart={startQuiz} />}
      {screen === "quiz" && <Quiz onComplete={completeQuiz} onExit={restart} />}
      {screen === "result" && result && (
        <Result result={result} onRestart={restart} />
      )}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppInner />
    </LanguageProvider>
  );
}

export default App;
